<div class="aca-mig__toolbar">
  <button type="button" class="aca-mig__btn aca-mig__btn--primary" (click)="newMigration()">
    <mat-icon>add</mat-icon>{{ 'DMS.MIGRATION.NEW_MIGRATION' | translate }}
  </button>
  <button type="button" class="aca-mig__btn" (click)="manageConnections()">
    <mat-icon>cable</mat-icon>{{ 'DMS.MIGRATION.MANAGE_CONNECTIONS' | translate }}
  </button>
</div>

<!-- summary cards -->
<div class="aca-mig__stats">
  <div class="aca-mig__stat">
    <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.STAT_TOTAL' | translate }}</div>
    <div class="aca-mig__statvalue">{{ jobs().length }}</div>
  </div>
  <div class="aca-mig__stat">
    <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.STAT_RUNNING' | translate }}</div>
    <div class="aca-mig__statvalue">{{ count(['running', 'paused']) }}</div>
  </div>
  <div class="aca-mig__stat">
    <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.STAT_COMPLETED' | translate }}</div>
    <div class="aca-mig__statvalue">{{ count(['completed', 'completed-warnings']) }}</div>
  </div>
  <div class="aca-mig__stat">
    <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.STAT_FAILED' | translate }}</div>
    <div class="aca-mig__statvalue">{{ count(['failed']) }}</div>
  </div>
  <div class="aca-mig__stat">
    <div class="aca-mig__statlabel">{{ 'DMS.MIGRATION.STAT_DOCS' | translate }}</div>
    <div class="aca-mig__statvalue">{{ documentsMigrated().toLocaleString() }}</div>
  </div>
</div>

<!-- recent jobs -->
<section class="aca-mig__card">
  <h3 class="aca-mig__cardtitle">{{ 'DMS.MIGRATION.RECENT' | translate }}</h3>

  <div class="aca-mig__empty" *ngIf="!loading && !jobs().length">
    <mat-icon>cloud_sync</mat-icon>
    <div class="aca-mig__emptytitle">{{ 'DMS.MIGRATION.EMPTY_JOBS_TITLE' | translate }}</div>
    <div>{{ 'DMS.MIGRATION.EMPTY_JOBS_DESC' | translate }}</div>
    <button type="button" class="aca-mig__btn aca-mig__btn--primary" (click)="newMigration()">
      <mat-icon>add</mat-icon>{{ 'DMS.MIGRATION.NEW_MIGRATION' | translate }}
    </button>
  </div>

  <div class="aca-mig__tablewrap" *ngIf="jobs().length">
    <table class="aca-mig__table">
      <thead>
        <tr>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_JOB' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_NAME' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_SOURCE' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DEST' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_PROGRESS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DOCS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STATUS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STARTED' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DURATION' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of recent(); trackBy: trackById" (click)="openJob()" style="cursor: pointer">
          <td class="aca-mig__td aca-mig__mono">{{ job.id?.slice(0, 8) || '—' }}</td>
          <td class="aca-mig__td">{{ job.name }}</td>
          <td class="aca-mig__td">{{ connectorName(job.sourceConnector) }}</td>
          <td class="aca-mig__td">{{ 'DMS.MIGRATION.DEST_CURRENT' | translate }}</td>
          <td class="aca-mig__td" style="min-width: 140px">
            <mat-progress-bar class="aca-mig__progress" mode="determinate" [value]="percent(job)" />
          </td>
          <td class="aca-mig__td">{{ docsOf(job) }}</td>
          <td class="aca-mig__td">
            <span class="aca-mig__chip" [ngClass]="statusClass(job.status)">{{ statusKey(job.status) | translate }}</span>
          </td>
          <td class="aca-mig__td">{{ dateLabel(job.startedAt || job.createdAt) }}</td>
          <td class="aca-mig__td">{{ duration(job) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
